import * as yup from "yup";

export const createErrorTransactionValidation = () => yup.object({
  notesForAdmin: yup.string()
    .required('Notes for Admin is required')
    .min(4, 'Notes for Admin must be at least 4 characters'),
  transactionReasonID: yup.number()
    .transform(value => (isNaN(value) ? undefined : value))
    .required('Transaction Reason is required'),
  notesForBee: yup.string()
    .notRequired(), 
  amount: yup.number()
    .transform(value => (isNaN(value) ? undefined : value))
    .min(0, "Amount must be a positive number")
    .required("Amount is required")
    .nullable(),
});